import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed top-0 left-0 z-10 h-screen w-screen bg-nucleus-lightestBlue overflow-auto" }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { class: "bg-nucleus-white" }
const _hoisted_4 = { class: "flex items-center px-4 py-6 border-b" }
const _hoisted_5 = { class: "text-2xl" }
const _hoisted_6 = { class: "px-4 pt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!
  const _component_ErrorBox = _resolveComponent("ErrorBox")!
  const _component_ModalDeleteCheck = _resolveComponent("ModalDeleteCheck")!
  const _component_HeaderMini = _resolveComponent("HeaderMini")!
  const _component_HeaderShadow = _resolveComponent("HeaderShadow")!
  const _component_InfoItem = _resolveComponent("InfoItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LoadingScreen, {
      loaded: _ctx.loaded,
      message: _ctx.loadingMessage
    }, null, 8, ["loaded", "message"]),
    (_ctx.errorHeading || _ctx.errorContent)
      ? (_openBlock(), _createBlock(_component_ErrorBox, {
          key: 0,
          heading: _ctx.errorHeading,
          content: _ctx.errorContent,
          fixed: _ctx.errorFixed,
          onCloseError: _cache[0] || (_cache[0] = ($event: any) => {
        _ctx.errorHeading = '';
        _ctx.errorContent = '';
      })
        }, null, 8, ["heading", "content", "fixed"]))
      : _createCommentVNode("", true),
    (_ctx.deleteCheck)
      ? (_openBlock(), _createBlock(_component_ModalDeleteCheck, {
          key: 1,
          text: _ctx.$t('global.defaults.localUser', 1),
          onCloseModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteCheck = false)),
          onDeleteMe: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteUser()))
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_HeaderMini, {
            name: _ctx.$t('global.defaults.localUser', 2),
            to: { name: 'localUsers' },
            "can-delete": true,
            "can-edit": true,
            "can-resend": _ctx.user.status === 'FORCE_CHANGE_PASSWORD',
            text: _ctx.$t('global.defaults.localUser', 1),
            "no-menu": !_ctx.localAdmin || _ctx.currentUser.attributes.sub === _ctx.user.userId,
            onDeleteCheck: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteCheck = true)),
            onEdit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.edit())),
            onResend: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resend()))
          }, null, 8, ["name", "can-resend", "text", "no-menu"]),
          _createVNode(_component_HeaderShadow),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-3xl leading-none p-2 mr-6 flex self-center transition bg-nucleus-primaryBlue text-nucleus-white rounded-full icon-user" }, null, -1)),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.user.name), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_InfoItem, {
                heading: _ctx.$t('global.defaults.headingAccountStatus'),
                value: _ctx.mapUserStatus(_ctx.user.status)
              }, null, 8, ["heading", "value"]),
              _createVNode(_component_InfoItem, {
                heading: _ctx.$t('global.defaults.headingName'),
                value: _ctx.user.name
              }, null, 8, ["heading", "value"]),
              _createVNode(_component_InfoItem, {
                heading: _ctx.$t('global.defaults.headingMobilePhone'),
                value: _ctx.user.phone
              }, null, 8, ["heading", "value"]),
              _createVNode(_component_InfoItem, {
                heading: _ctx.$t('global.defaults.headingEmail'),
                value: _ctx.user.email
              }, null, 8, ["heading", "value"]),
              (_ctx.user.createdDate)
                ? (_openBlock(), _createBlock(_component_InfoItem, {
                    key: 0,
                    heading: _ctx.$t('global.defaults.headingDateCreated'),
                    value: _ctx.getDate(_ctx.user.createdDate)
                  }, null, 8, ["heading", "value"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}